import { EmptyState, EmptyStateSize } from '@pdcplan/shared/components';
import React from 'react';
import { colors } from '@pdcfrontendui/components';
import { currentLanguage } from '../currentLanguage';

function NoCandidatesImage() {
  return (
    <svg
      width="221px"
      height="203px"
      viewBox="0 0 221 203"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Empty-state/Illustration/NoCandidates"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g transform="translate(0, 0)">
          <rect x="11.0213608" y="0" width="203" height="203"></rect>
          <g
            transform="translate(110.5214, 101.4741) rotate(-7.3085) translate(-110.5214, -101.4741)translate(9.7829, 18.138)"
            fill={colors.colorPrimaryLightest}
            fillRule="nonzero"
          >
            <path d="M155.44994,35.1031197 C174.139255,45.2129398 197.202664,50.0851422 200.914017,61.656623 C204.62537,73.3499089 188.984668,91.9860833 183.285089,110.256842 C177.585511,128.527602 181.959606,146.432946 174.669448,156.177351 C167.37929,166.043561 148.424879,167.870636 132.651627,166.043561 C116.878376,164.33829 104.153737,159.100672 85.3318738,159.953307 C66.6425593,160.684138 41.8560216,167.505221 24.4921905,161.536773 C7.26090761,155.568325 -2.68021711,136.688541 0.633491127,119.635832 C3.94719937,102.704929 20.5157406,87.357491 28.9988337,68.2340964 C37.6144751,49.1107017 38.2772167,26.0895452 50.0740181,13.0564036 C61.8708194,0.0232620428 84.9342288,-3.14366955 103.623543,3.06838857 C122.312858,9.2804467 136.628077,24.8714945 155.44994,35.1031197 Z"></path>
          </g>
          <g transform="translate(54, 45)">
            <circle
              fill={colors.colorPrimaryUltraLightest}
              cx="56.2906548"
              cy="36.7132776"
              r="28.7346939"
            ></circle>
            <g id="user" fill={colors.colorPrimaryDark} fillRule="nonzero">
              <path d="M108.566491,97.9296482 C105.73192,91.1935563 101.618444,85.0749165 96.4552095,79.9145728 C91.3076571,74.7393379 85.209893,70.6131323 78.4986561,67.7638191 C78.4385505,67.7336683 78.3784449,67.7185929 78.3183393,67.6884422 C87.6797893,60.9045226 93.7654831,49.8542713 93.7654831,37.3869347 C93.7654831,16.7336683 77.0861741,0 56.5,0 C35.9138259,0 19.2345169,16.7336683 19.2345169,37.3869347 C19.2345169,49.8542713 25.3202107,60.9045226 34.6816607,67.7035176 C34.6215551,67.7336683 34.5614495,67.7487437 34.5013439,67.7788944 C27.7695147,70.6281407 21.7289001,74.7135678 16.5447905,79.9296482 C11.3863674,85.0939769 7.27356578,91.2116142 4.43350854,97.9447236 C1.64343835,104.536478 0.138690633,111.603695 0.000343020705,118.763819 C-0.00738319373,119.08887 0.115681574,119.403431 0.342005533,119.636169 C0.568329493,119.868908 0.878735606,120 1.20283158,120 L10.2186743,120 C10.8798361,120 11.4057602,119.472362 11.4207866,118.824121 C11.7213147,107.18593 16.3795001,96.2864321 24.6139697,88.0251256 C33.1339411,79.4773869 44.4488236,74.7738693 56.5,74.7738693 C68.5511764,74.7738693 79.8660589,79.4773869 88.3860303,88.0251256 C96.6204999,96.2864321 101.278685,107.18593 101.579213,118.824121 C101.59424,119.487437 102.120164,120 102.781326,120 L111.797168,120 C112.121264,120 112.431671,119.868908 112.657994,119.636169 C112.884318,119.403431 113.007383,119.08887 112.999657,118.763819 C112.849017,111.557789 111.361403,104.547739 108.566491,97.9296482 Z M56.5,63.3165829 C49.6028804,63.3165829 43.1114736,60.6180904 38.2278922,55.7185929 C33.3443107,50.8190955 30.6545843,44.3065326 30.6545843,37.3869347 C30.6545843,30.4673367 33.3443107,23.9547739 38.2278922,19.0552764 C43.1114736,14.1557789 49.6028804,11.4572864 56.5,11.4572864 C63.3971196,11.4572864 69.8885264,14.1557789 74.7721078,19.0552764 C79.6556893,23.9547739 82.3454157,30.4673367 82.3454157,37.3869347 C82.3454157,44.3065326 79.6556893,50.8190955 74.7721078,55.7185929 C69.8885264,60.6180904 63.3971196,63.3165829 56.5,63.3165829 Z"></path>
            </g>
            <ellipse
              fill={colors.colorPrimaryDark}
              cx="56.5561373"
              cy="49.2443912"
              rx="3.68396833"
              ry="3.75560884"
            ></ellipse>
          </g>
          <path
            d="M175.64064,74.2490861 L175.64064,70.1175977 L183.001363,61.4993901 C184.209591,60.0939118 185.103453,59.0977212 185.682948,58.5030957 C185.079213,58.5417078 184.283827,58.564875 183.297549,58.5803198 L176.362547,58.6189319 L176.362547,54.2248816 L192.599771,54.2248816 L192.599771,57.977972 L185.091333,66.8046846 L182.446866,69.7237549 C183.889165,69.6388084 184.783026,69.5924739 185.128451,69.5924739 L193.173206,69.5924739 L193.173206,74.2490861 L175.64064,74.2490861 Z"
            fill={colors.colorPrimaryBaseDark}
            fillRule="nonzero"
          ></path>
          <path
            d="M153.844333,50.0045313 L153.844333,43.4490419 L164.870358,29.7744134 C166.680228,27.5443216 168.019192,25.9636522 168.887249,25.0201518 C167.982881,25.0814181 166.79143,25.1181779 165.314031,25.1426844 L154.925716,25.2039506 L154.925716,18.2318506 L179.248331,18.2318506 L179.248331,24.1869308 L168.001036,38.192397 L164.039746,42.824126 C166.200244,42.6893403 167.539207,42.6158208 168.056637,42.6158208 L180.10731,42.6158208 L180.10731,50.0045313 L153.844333,50.0045313 Z"
            fill={colors.colorPrimaryBaseDark}
            fillRule="nonzero"
          ></path>
          <g
            transform="translate(92.0214, 78.9741)"
            stroke={colors.colorPrimaryDark}
            strokeWidth="2.33231503"
          >
            <path d="M12,0.00582362729 C11.073928,2.63311148 8.73622598,4.5 6.00076346,4.5 C3.26377402,4.5 0.924545108,2.62978369 0,0"></path>
            <path d="M36,0.00582362729 C35.073928,2.63311148 32.736226,4.5 30.0007635,4.5 C27.263774,4.5 24.9245451,2.62978369 24,0"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default function NoCandidates({ className }: { className?: string }) {
  return (
    <EmptyState
      image={NoCandidatesImage}
      className={className}
      heading={currentLanguage.NoCandidates}
      description={currentLanguage.NoCandidatesLong}
      size={EmptyStateSize.Medium}
    />
  );
}
